import { AuthContextProps } from "../components/auth-context";
import RegisterBankReceiptForm from "../types/bank-receipt";
import { getData, postData } from "./core";
export default class RegisterBankReceiptApi {
  static unauthorizedUri = "n/accounts/registerBankReceipt";
  static authorizedUri = "a/accounts/registerBankReceipt";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }

  get() {
    return getData({
      id:'_',
      uri: RegisterBankReceiptApi.unauthorizedUri,
      context: this.context,
    });
  }
  
  post(data: RegisterBankReceiptForm) {
    return postData({
      uri: RegisterBankReceiptApi.unauthorizedUri,
      context: this.context,
      data 
    });
  }

 }
